export const PDF_PREVIEW_SESSION_KEY = 'westhaven26-pdf-preview'

export function syncPdfPreviewSessionFromUrl() {
	if (typeof window === 'undefined') return
	const params = new URLSearchParams(window.location.search || '')
	let rawValue = null
	for (const [key, val] of params.entries()) {
		if (key.toLowerCase() === 'pdfpreview') {
			rawValue = val
			break
		}
	}
	if (rawValue === null) return
	try {
		const raw = (rawValue || '1').toLowerCase()
		if (raw === '0' || raw === 'false') {
			sessionStorage.removeItem(PDF_PREVIEW_SESSION_KEY)
		} else {
			sessionStorage.setItem(PDF_PREVIEW_SESSION_KEY, '1')
		}
	} catch (_) {}
}

function isPdfPreviewEnabledInUrl() {
	if (typeof window === 'undefined') return false
	const params = new URLSearchParams(window.location.search || '')
	for (const [key, val] of params.entries()) {
		if (key.toLowerCase() !== 'pdfpreview') continue
		const raw = (val || '1').toLowerCase()
		return raw !== '0' && raw !== 'false'
	}
	return false
}

export function isPdfPreviewMode() {
	if (typeof window === 'undefined') return false
	syncPdfPreviewSessionFromUrl()
	try {
		if (sessionStorage.getItem(PDF_PREVIEW_SESSION_KEY) === '1') return true
	} catch (_) {}
	return isPdfPreviewEnabledInUrl()
}
